import type { ReactNode } from "react";
import { GenericLabel } from "./GenericLabel";

type Props = {
  title?: ReactNode;
  imageUrl?: string;
};

export const EntityGroupLabel = ({ title, imageUrl }: Props) => {
  return <GenericLabel title={title} imageUrl={imageUrl} avatarIcon="fa-sitemap" />;
};
